import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const OAuthRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { handleOAuthRedirect } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const error = urlParams.get('error');

    if (error) {
      console.error('OAuth error:', error);
      navigate('/loginPage?error=oauth_failed');
      return;
    }

    if (token) {
      try {
        handleOAuthRedirect(token);
        // Redirect to dashboard
        navigate('/');
      } catch (error) {
        console.error('Failed to process OAuth redirect:', error);
        navigate('/loginPage?error=token_invalid');
      }
    } else {
      // Only show error if this is the first mount and no token
      console.error('No token found in URL');
      navigate('/loginPage?error=no_token');
    }
  }, [navigate, handleOAuthRedirect]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress size={48} />
      <Typography variant="h6" color="textSecondary">
        Processing your login...
      </Typography>
    </Box>
  );
};

export default OAuthRedirect; 